export default "__VITE_ASSET__CD_a72gX__"